import React from 'react';

const Header = ({titulo, cantidad}) => (
        <h1>{cantidad}</h1>
      );
 
export default Header;